import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router';
import { getSiteLogo, getSiteName } from '../../../utils/brandingConfig';

import { HTTPErrors } from './ErrorCodes';
import HomePageSuggesstion from '../../Home/HomePageSuggesstion';

import './style/styles.css';
import '../CommingSoon/Face2Face/style/Styles.css';

const Bricks = "https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/bricks.png";
const oopsImage = "https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/oops.png";
const radGradient = "https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/radial_gradient.png";

export default function Error({ userDetails, userPosts }) {
  const logo = getSiteLogo({ isDark: true });
  const siteName = getSiteName();

  const errorComponent = useSelector((state) => state.component.errorComponent);
  const { code } = useParams();

  const [error, setError] = useState({});

  const navigate = useNavigate();

  const goToHome = () => navigate("/home");

  const userNotFound = (userDetails && userDetails?.error === 'The user is not found') || (userPosts && userPosts?.error === 'The user is not found')

  useEffect(() => {
    const errorObj = HTTPErrors.filter((error) => error.status == (code || errorComponent?.data?.status));
    if (userNotFound) {
      setError({ status: "", message: "This user is not active" });
    } else if ((code || errorComponent?.data?.status) && errorObj.length) {
      setError(errorObj[0]);
    } else {
      setError({ status: "404", message: "Page not found" });
    }
  }, [code]);

  const helmetTitle = userNotFound
    ? 'This user is no longer available.'
    : (error?.message || 'Page not found');

  return (
    <>
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <div className="bg-black error-height" >
        <div className="face2face">
          <img
            src={radGradient}
            className='background-image error-image image-gradiennt'
            alt={siteName}
            id='stripper_logo'
            aria-label='gradient-image'
          />
          <div className="error-background-image-layer"></div>
          <img
            src={Bricks}
            className='background-image error-image'
            alt={siteName}
            id='stripper_logo'
            aria-label='bricks'
          />
        </div>
        <div className="bg-grad">
          <div className="wrapper-sec-face2face error-page-container">
            <div className="page container error main-container container-fluid ">
              <div className="d-flex flex-column align-items-center " style={{zIndex:4}}>
                <Row className="mt-5">
                  <img
                    role={'button'}
                    onClick={goToHome}
                    src={logo}
                    className='img-fluid mr-0'
                    alt={siteName}
                    id='stripper_logo'
                    aria-label={`${siteName} logo`}
                  />
                </Row>
                <Row className="mt-5">
                  <h1 className="error-code">{error?.status}</h1>
                </Row>
                <div className="blur-container"></div>
                <Row className="mt-1">
                  {
                    !userNotFound &&
                    <img
                      src={oopsImage}
                      className='opps-img'
                      alt='OOPSs'
                      aria-label='oops'
                    />
                  }
                </Row>
                <Row className={userNotFound ? "mt-0" : "mt-1"}>
                  <h2 className="error-message text-center">{error?.message}</h2>
                </Row>
                {
                  userNotFound &&
                  <Row>
                    <HomePageSuggesstion userNotFound={userNotFound} />
                  </Row>
                }

                {error?.status === "404" &&
                  <Row className="mt-1">
                    <button className="primary-button mt-3" onClick={goToHome}>
                      Return Home
                    </button>
                  </Row>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
